import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { getAll as getAllPosjete } from "../../services/statistikaDokumenta.service";
import dokumentService from "../../services/dokument.service";
import { subDays, isAfter, parseISO } from "date-fns";
import "./NajposjecenijiDokumenti.css";

const colors = ["#f7d6a8", "#ffcfa8", "#ffd1b8", "#fff4b8", "#fff6d9"];

const CustomTick = ({ x, y, payload }) => {
  const puniNaziv = payload.value || "";
  const prikazaniNaziv =
    puniNaziv.length > 15 ? puniNaziv.slice(0, 20) + "…" : puniNaziv;

  return (
    <g transform={`translate(${x},${y})`}>
      <title>{puniNaziv}</title>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        fill="#666"
        transform="rotate(-30)"
        fontSize={13}
      >
        {prikazaniNaziv}
      </text>
    </g>
  );
};

const NajposjecenijiDokumenti = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: dokumenti } = await dokumentService.getAll();
        const mapaDokumenata = {};
        dokumenti.forEach((dokument) => {
          mapaDokumenata[dokument.id] = dokument.naziv;
        });

        const { data: svePosjete } = await getAllPosjete();
        const sedamDanaUnazad = subDays(new Date(), 7);

        const posjeteZadnjih7Dana = svePosjete.filter((p) => {
          const datum = parseISO(p.vremenskaOznaka || p.vremenska_oznaka);
          return isAfter(datum, sedamDanaUnazad);
        });

        const brojac = {};
        posjeteZadnjih7Dana.forEach((posjeta) => {
          const dokumentId = posjeta.dokumentId;
          if (!brojac[dokumentId]) brojac[dokumentId] = 0;
          brojac[dokumentId]++;
        });

        const rezultat = Object.entries(brojac)
          .map(([id, posjete], index) => ({
            naziv: mapaDokumenata[id] || `Dokument ${id}`,
            posjete,
            fill: colors[index % colors.length],
          }))
          .sort((a, b) => b.posjete - a.posjete)
          .slice(0, 5);

        setData(rezultat);
      } catch (error) {}
    };

    fetchData();
  }, []);

  return (
    <div className="najposjeceniji-dokumenti-container">
      <h2 className="najposjeceniji-dokumenti-heading">
        Top 5 najposjećenijih dokumenata u zadnjih 7 dana
      </h2>
      {data.length === 0 ? (
        <div className="text-center">Nema podataka za prikaz.</div>
      ) : (
        <div className="chart-wrapper">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
            >
              <XAxis
                dataKey="naziv"
                tick={<CustomTick />}
                interval={0}
                height={100}
              />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="posjete" name="Broj posjeta" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default NajposjecenijiDokumenti;
